/* eslint-disable react/no-unescaped-entities */
import React, { useEffect } from "react";
import styles from "./ReferralPage.css";
import backend from "utils/backend";
import { parse } from "qs";
import Log from "utils/log";
import PropTypes from "prop-types";
import { REFERRAL_PROGRAMS } from "../../config/constants";

export default function OptInConfirmationPage(props) {
  useEffect(() => {
    // Get referral data from query params
    const queryParams = parse(props.location.search.slice(1));
    const data = {
      referred_to_list: queryParams.referred_to_list,
      email: queryParams.email,
      referred_by: queryParams.referred_by,
    };

    // Make API request to complete the referral
    backend
      .request({
        method: "POST",
        url: "/refer/finish/",
        data,
      })
      .catch(error => {
        Log.error(error);
      });
  }, []); // Pass an empty array so this only runs once
  const newsletter = REFERRAL_PROGRAMS[props.match.params.newsletter];
  return (
    <div className={styles.root}>
      <div className={styles.confirmation}>
        <div>
          <h1>It's official, you're in!</h1>
        </div>
        <p>
          You're now part of the <strong>{newsletter.name}</strong> community
          and one of hundreds of thousands of people getting smarter, faster
          with <strong>Axios</strong> newsletters!
        </p>
        <p>
          At <strong>Axios</strong> &mdash; the Greek word for worthy &mdash; we
          provide only content worthy of people’s time, attention and trust.
        </p>
        <p>
          <strong>Here's what to expect from all of our newsletters</strong>
        </p>
        <div>
          <ul>
            <li>
              We'll share the most consequential stories shaping the day &mdash;
              and the next decade &mdash; curated by our subject-matter experts.
            </li>
            <li>
              We'll tell you why each story matters, with insights driven by
              years of reporting.
            </li>
            <li>
              And it's all in Smart Brevity &mdash; we know you're busy, so
              we'll be efficient.
            </li>
            <li>
              <a href="https://www.axios.com/newsletters" target="_blank">
                What's next: Check out all of the Axios newsletters
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

OptInConfirmationPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};
